export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7176.6dc13505.jpg";